// 全局组件
/* eslint-disable */
import Viewer from 'v-viewer' // pc图片放大缩小
import 'viewerjs/dist/viewer.css'
export default {
    install: function (Vue) {
        Vue.component('autoQuitTips', resolve => require(['base/auto-quit-tips'], resolve)) // group组件
        Vue.component('errorNull', resolve => require(['base/errorNull'], resolve)) // 网络加载异常
        // 自定义指令-添加全局资源（默认图片）
        Vue.directive('handleImgTX', {
            bind(e, binding, vnode, oldVnode) {
                e.src = binding.value instanceof Array ? binding.value[0] : binding.value
                e.onerror = function () {
                    var img = new Image()
                    var imgAttr = binding.value instanceof Array ? binding.value[1] : require('@/assets/images/photo.png')
                    // 改变图片的src
                    img.src = imgAttr
                    setTimeout(() => {
                        if ((img.filesize > 0 || (img.width > 0 && img.height > 0)) && e.src) {
                            e.src = imgAttr
                        } else {
                            // console.log('默认图片也不存在')
                            img.οnerrοr = null
                            // 默认图片也不存在的时候
                        }
                    }, 300)
                }
            }
            // function (e, binding, vnode, oldVnode) {
            // };
        })
        // 自定义过滤器
        Vue.filter('to-uppercase', function (value) {
            // 变为大写
            return value.toUpperCase()
        })
        Vue.filter('SetFigure', function (num, name) {
            num = Number(num)

            function NumberToChinese(num) {
                var unitPos = 0
                var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
                var chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
                var strIns = ''
                var chnStr = ''
                var needZero = false
                if (num === 0) {
                    return chnNumChar[0]
                }

                while (num > 0) {
                    var section = num % 10000
                    if (needZero) {
                        chnStr = chnNumChar[0] + chnStr
                    }
                    strIns = SectionToChinese(section)
                    strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0]
                    chnStr = strIns + chnStr
                    needZero = section < 1000 && section > 0
                    num = Math.floor(num / 10000)
                    unitPos++
                }

                return chnStr
            }

            function SectionToChinese(section) {
                var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
                var chnUnitChar = ['', '十', '百', '千']
                var strIns = ''
                var chnStr = ''
                var unitPos = 0
                var zero = true
                while (section > 0) {
                    var v = section % 10
                    if (v === 0) {
                        if (!zero) {
                            zero = true
                            chnStr = chnNumChar[v] + chnStr
                        }
                    } else {
                        zero = false
                        strIns = chnNumChar[v]
                        strIns += chnUnitChar[unitPos]
                        chnStr = strIns + chnStr
                    }
                    unitPos++
                    section = Math.floor(section / 10)
                }
                return chnStr
            }
            return NumberToChinese(num) + (name || '')
        })

        // 过渡收缩
        Vue.directive('ShowShrink', {
            inserted: function (el, binding, vnode) {
                el.style.overflow = 'hidden'
                el.style.opacity = binding.value ? 1 : 0
                el.style['box-sizing'] = 'border-box'
                el.style.width = '100%'
                if (!binding.value) {
                    el.style.height = 'auto'
                    el.style.left = '-9999px'
                    el.style.position = 'absolute'
                    el.style.visibility = 'hidden'
                } else {
                    el.style.position = ''
                    el.style.visibility = ''
                    el.style.transition = 'all .3s'
                    el.style.height = el.offsetHeight + 'px'
                }
            },
            update: function (el, binding, vnode) {
                setTimeout(() => {
                    if (!binding.value) {
                        el.style.opacity = 0
                        el.style.height = '0px'
                        el.style.padding = 0
                        el.style.position = ''
                        el.style.visibility = ''
                        setTimeout(() => {
                            if (parseInt(el.style.height) === 0) {
                                el.style.position = 'absolute'
                                el.style.visibility = 'hidden'
                            }
                            el.style.height = 'auto'
                            el.style.padding = ''
                        }, 300)
                    } else {
                        if (parseInt(el.style.height) > 0) return
                        var Height = el.offsetHeight
                        el.style.transition = ''
                        el.style.padding = 0
                        el.style.position = ''
                        el.style.visibility = ''
                        el.style.height = '0px'
                        setTimeout(() => {
                            // if (parseInt(el.style.height) > 0) return;
                            el.style.transition = 'all .3s'
                            el.style.height = binding.value ? Height + 'px' : '0px'
                            el.style.opacity = 1
                            el.style.padding = ''
                        }, 30)
                    }
                }, 30)
            }
        })
        //设置滚动条
        Vue.directive('SetScrollbar', {
            update: function (el, binding, vnode) {
                var obj_class = binding.value ? 'default-scrollbar appscrollbar el-scrollbar' : ''
                if (el.getAttribute('class') !== obj_class) {
                    //避免重复操作
                    el.className = obj_class //替换原来的 class.
                }
            }
        })
        // 判断文本框 聚焦、失去焦点
        Vue.directive('pdJD', {
            componentUpdated: function (el, binding, vnode) {
                // let oriWinHeight = window.innerHeight
                // sessionStorage.setItem('v-pdJD', oriWinHeight)
            },
            update: function (e, binding, vnode) {
                let oriWinHeight = window.innerHeight
                window.onresize = function (ev) {
                    let newHeight = window.innerHeight
                    pdJD(e, newHeight, oriWinHeight)
                }

                function pdJD(e, newHeight, oriWinHeight) {
                    if (!binding.value || newHeight >= oriWinHeight) {
                        e.style.display = ''
                        e.style['pointer-events'] = ''
                        e.style.opacity = 1
                        window.onresize = ''
                    } else {
                        // alert(newHeight)
                        // alert(oriWinHeight)
                        e.style['pointer-events'] = 'none'
                        e.style.transition = 'all 0s'
                        e.style.opacity = 0
                        e.style.display = 'none'
                    }
                }
            }
        })

        // 滚动条
        Vue.directive('scrllPull', {
            bind(e, binding) {
                Vue.nextTick(() => {
                    var demo = e.parentElement
                    var dp = e
                    demo.style.position = 'fixed'
                    demo.style.width = '100%'
                    demo.style.height = '100%'
                    e.style.transition = 'all 0.1s'
                    e.style.height = '100%'
                    e.style.position = 'initial'
                    e.style.height = 'auto'
                    var odiv = document.createElement('div') // 创建一个div
                    var styles = {
                        width: '10px',
                        'border-radius': '18px',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        background: '#999',
                        cursor: 'pointer',
                        opacity: 1,
                        transition: 'all 0s',
                        display: 'block'
                    }
                    // 获取dp的长度
                    var dpHeight = e.offsetHeight
                    // 获取demo的长度
                    var demoHeight = demo.offsetHeight
                    // 根据比值计算scrll的长度
                    var scrllHeight = (demoHeight * demoHeight) / dpHeight
                    if (dp.offsetHeight < demo.offsetHeight) {
                        scrllHeight = 0
                    }
                    styles.height = scrllHeight + 'px'
                    // scrll.style.height = scrllHeight + 'px'
                    // 获取滚动条和内容移动距离的比例
                    for (var i in styles) {
                        odiv.style[i] = styles[i]
                    }
                    odiv.className = 'scrll'
                    if (!document.querySelector('.scrll')) {
                        demo.appendChild(odiv) // 把div添加到body中
                    }
                    let scrll = document.querySelector('.scrll')
                    var bilu = (dp.offsetHeight - demo.offsetHeight) / (demo.offsetHeight - scrll.offsetHeight)
                    // 滚动条滚动事件
                    scrll.addEventListener('mousedown', function (event) {
                        scrll.style.transition = 'all 0.05s'
                        scrll.style.opacity = 1
                        incident(event, bilu, demo, scrll, dp)
                        scrll.onmouseleave = null
                    })
                    if (scrllHeight > 0 && document.addEventListener) {
                        if (document.addEventListener) {
                            // 兼容问题
                            // W3C FF
                            document.addEventListener(
                                'DOMMouseScroll',
                                function (event) {
                                    e.style.transition = 'all .1s'
                                    scrll.style.transition = 'all 0.1s'
                                    scrll.style.opacity = 1
                                    incidentScr(event, bilu, demo, scrll, dp)
                                },
                                false
                            )
                        }
                        // IE/Opera/Chrome/Safari
                        window.onmousewheel = document.onmousewheel = function (event) {
                            e.style.transition = 'all .1s'
                            scrll.style.transition = 'all 0.1s'
                            scrll.style.opacity = 1
                            incidentScr(event, bilu, demo, scrll, dp)
                        }
                    }

                    scrll.onmouseover = function (event) {
                        // event.stopPropagation()
                        scrll.style.transition = 'all 0s'
                        scrll.style.opacity = 1
                    }
                    scrll.onmouseleave = function (event) {
                        scrll.style.transition = 'all .5s'
                        scrll.style.opacity = 0
                    }
                    document.onmouseup = function () {
                        document.onmousemove = null
                        scrll.style.transition = 'all 1s'
                        window.setTimeout(() => {
                            scrll.style.opacity = 0
                        }, 300)
                    }
                })

                function incidentScr(event, bilu, demo, scrll, dp) {
                    // eslint-disable-next-line no-redeclare
                    var moveY = scrll.offsetTop
                    if (event.detail) {
                        moveY = event.detail > 0 ? moveY + 50 : moveY - 50
                    } else if (event.wheelDelta) {
                        moveY = event.wheelDelta < 0 ? moveY + 50 : moveY - 50
                    } else {
                        moveY = event.deltaY > 0 ? moveY + 50 : moveY - 50
                    }

                    if (moveY < 0) {
                        moveY = 0
                    }
                    if (moveY > demo.offsetHeight - scrll.offsetHeight) {
                        moveY = demo.offsetHeight - scrll.offsetHeight
                    }
                    scrll.style.top = moveY + 'px'
                    dp.style.top = -moveY * bilu + 'px'
                }

                function incident(event, bilu, demo, scrll, dp) {
                    console.log(scrll)
                    // event兼容性解决
                    // console.log(demo.offsetTop)
                    // eslint-disable-next-line no-redeclare
                    var event = event || window.event
                    // 获取鼠标按下的页面坐标
                    // 滚动条滚动时只有top值改变，所有不需要获取pageX
                    var pageY = event.pageY || event.clientY + document.documentElement.scrollTop
                    // 获取鼠标在scrll内的坐标
                    var scrllY = pageY - demo.offsetTop - scrll.offsetTop
                    // 给document绑定鼠标移动事件
                    document.onmousemove = function (event) {
                        // eslint-disable-next-line no-redeclare
                        var event = event || window.event
                        // 获取鼠标移动时的坐标
                        var moveY = event.pageY || event.clientY + document.documentElement.scrollTop
                        // 获取滚动条的移动坐标
                        var trueY = moveY - scrllY - demo.offsetTop
                        // 限制滚动条移动的范围
                        if (trueY < 0) {
                            trueY = 0
                        }
                        if (trueY > demo.offsetHeight - scrll.offsetHeight) {
                            trueY = demo.offsetHeight - scrll.offsetHeight
                        }
                        scrll.style.top = trueY + 'px'
                        // 清除选中文字
                        window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty()
                        // 获取文字区域移动的距离
                        var dpY = trueY * bilu
                        dp.style.top = -dpY + 'px'
                    }
                }
            }
            // updated (e) {
            //   console.log(e)
            // }
        })
        // 横向滚动过渡
        Vue.directive('Slider', {
            inserted: function (el, binding, vnode) {
                var evchild = el.children[0]
                var scrWidth = el.scrollWidth
                var setWidth = el.offsetWidth
                var val = 0
                var time = 0
                el.children[0].style.width = scrWidth + 'px'
                el.children[0].style.background = '#fff'
                evchild.style.transform = `translate(0px, 0px) scale(1) translateZ(0px)`
                if (scrWidth > setWidth) {
                    var x = 0
                    var s = 0
                    evchild.ontouchstart = function (e) {
                        evchild.style['transition-duration'] = `0ms`
                        s = e.timeStamp
                        x = e.touches[0].pageX
                        evchild.ontouchend = function (e3) {
                            // time = (e3.timeStamp - e.timeStamp) < 300 ? 500 : 1500
                            setTimeout(() => {
                                evchild.style['transition-duration'] = `0ms`
                            }, time)
                        }
                        evchild.ontouchmove = function (e2) {
                            e2.preventDefault()
                            val += (e2.touches[0].pageX - x) / 5 // 滚动速度
                            time = e2.timeStamp - s < 300 ? 500 : 1500
                            evchild.style['transition-duration'] = `${time}ms`
                            if (val >= 20) {
                                evchild.style['transition-duration'] = `300ms`
                                // val = 20
                                setTimeout(() => {
                                    val = 0
                                    evchild.style.transform = `translate(${val}px, 0px) scale(1) translateZ(0px)`
                                }, time)
                            } else if (Math.abs(val) > scrWidth + 20 - setWidth) {
                                // val = -(scrWidth + 20 - setWidth)
                                evchild.style['transition-duration'] = `300ms`
                                setTimeout(() => {
                                    val = -(scrWidth - setWidth)
                                    evchild.style.transform = `translate(${val}px, 0px) scale(1) translateZ(0px)`
                                }, time)
                            } else {
                                evchild.style.transform = `translate(${val}px, 0px) scale(1) translateZ(0px)`
                            }
                        }
                    }
                }
            }
        })
        // '全局函数'
        Vue.prototype.$loadingCar = require('@/assets/images/loading_carry.gif')
        //由于charts的字体在IE中不兼容rem，所以判断IE就用px,其他主流浏览器用rem，对放大缩小比较友好
        Vue.prototype.$isIE = () => {
            // 取得浏览器的userAgent字符串
            var userAgent = navigator.userAgent
            var isIE = window.ActiveXObject !== undefined && userAgent.indexOf('MSIE') > -1
            var isFirefox = userAgent.indexOf('Firefox') > -1
            var isOpera = window.opr !== undefined
            var isChrome = userAgent.indexOf('Chrome') && window.chrome
            var isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Version') > -1
            let judge = false
            if (isIE) {
                judge = true
            } else if (isFirefox) {
            } else if (isOpera) {
            } else if (isChrome) {
            } else if (isSafari) {
            } else {
                judge = true
            }
            return judge
        }
        Array.prototype.flat = function (count) {
            //es6 flzt语法 兼容IE
            let c = count || 1
            let len = this.length
            let exe = []
            if (this.length == 0) return this
            while (c--) {
                let _arr = []
                let flag = false
                if (exe.length == 0) {
                    flag = true
                    for (let i = 0; i < len; i++) {
                        if (this[i] instanceof Array) {
                            exe.push(...this[i])
                        } else {
                            exe.push(this[i])
                        }
                    }
                } else {
                    for (let i = 0; i < exe.length; i++) {
                        if (exe[i] instanceof Array) {
                            flag = true
                            _arr.push(...exe[i])
                        } else {
                            _arr.push(exe[i])
                        }
                    }
                    exe = _arr
                }
                if (!flag && c == Infinity) {
                    break
                }
            }
            return exe
        }

        // 图片放大缩小
        Vue.use(Viewer)
        Viewer.setDefaults({
            Options: {
                inline: true, // 启用 inline 模式
                button: true, // 显示右上角关闭按钮
                navbar: true, // 显示缩略图导航
                title: true, // 显示当前图片的标题
                toolbar: true, // 显示工具栏
                tooltip: true, // 显示缩放百分比
                movable: true, // 图片是否可移动
                zoomable: true, // 图片是否可缩放
                rotatable: true, // 图片是否可旋转
                scalable: true, // 图片是否可翻转
                transition: true, // 使用 CSS3 过度
                fullscreen: true, // 播放时是否全屏
                keyboard: true, // 是否支持键盘
                url: 'data-source' // 设置大图片的 url
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/common/js/global-component.js